import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "../../lib/AuthContext";
import { JACE } from "./shared";

export default function JaceLogin({ onSuccess }) {
  const nav = useNavigate();
  const { signIn, signOut } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true); // gym-iPad: standaard 30 dagen ingelogd blijven
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const user = await signIn(email, password, remember);
      if (!["admin", "owner"].includes(user?.role)) {
        signOut();
        setError("Geen coach-toegang — alleen coaches mogen in JACE");
        toast.error("Geen coach-toegang — alleen coaches mogen in JACE");
        return;
      }
      toast.success("JACE // SYSTEM ACTIVE");
      if (onSuccess) onSuccess(user);
      else nav("/jace/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = detail === "password_setup_required"
        ? "Dit account heeft nog geen wachtwoord — kies hieronder 'Wachtwoord vergeten?'"
        : (typeof detail === "string" ? detail : null)
        || (!err?.response ? "Login-service tijdelijk niet bereikbaar — probeer het zo opnieuw" : null)
        || formatApiError(detail)
        || "Login mislukt — controleer je gegevens en probeer opnieuw";
      setError(msg);
      toast.error(msg);
    } finally {
      setBusy(false); // knop nooit op "…" laten hangen
    }
  };

  return (
    <div className="jace-scope min-h-screen bg-[#0A0A0A] text-[#F5F3F0] grain grain-dark flex items-center justify-center p-6" data-testid="jace-login">
      <form onSubmit={submit} className="w-full max-w-sm border border-[#F5F3F0]/15 p-8 md:p-10">
        <div className="font-display uppercase text-5xl" style={{ color: JACE }}>JACE</div>
        <div className="chip text-[#A3A3A3] mt-2">JOH ATHLETIC COACHING ENGINE</div>
        <div className="chip mt-1" style={{ color: JACE }}>// AUTHORIZED ACCESS</div>
        <div className="mt-8 space-y-5">
          <div>
            <label className="chip text-[#A3A3A3]">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="editorial-input dark" data-testid="jace-login-email" />
          </div>
          <div>
            <label className="chip text-[#A3A3A3]">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="editorial-input dark" data-testid="jace-login-password" />
          </div>
          <label className="flex items-center gap-2 cursor-pointer select-none" data-testid="jace-login-remember-label">
            <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="w-4 h-4 accent-[#C6FF3C]" data-testid="jace-login-remember" />
            <span className="chip text-[#A3A3A3]">Ingelogd blijven (30 dagen)</span>
          </label>
          <button type="submit" disabled={busy} className="w-full py-3.5 chip border transition-colors"
            style={{ borderColor: JACE, color: busy ? "#A3A3A3" : "#0A0A0A", background: busy ? "transparent" : JACE }}
            data-testid="jace-login-submit">
            {busy ? "…" : "LOGIN"}
          </button>
          {error && (
            <div className="chip text-center" style={{ color: "#E8362A" }} data-testid="jace-login-error" role="alert">{error}</div>
          )}
          <div className="text-center">
            <Link to="/wachtwoord-vergeten" className="chip text-[#4A4A4A] hover:text-[#A3A3A3] transition-colors" data-testid="jace-login-forgot">Wachtwoord vergeten?</Link>
          </div>
        </div>
        <div className="chip text-[#4A4A4A] mt-6">BUILD. COACH. REVIEW. PROGRESS.</div>
      </form>
    </div>
  );
}